import block from "./block";
import component from "./component";

export default (editor, opts = {}) => {
  editor.DomComponents.addType("floatWhats", component(opts));
  editor.BlockManager.add("floatWhats", block(opts));
};